import { AppRegistry } from 'react-native';
import App from './App';

AppRegistry.registerComponent('pmsWeb', () => App);
AppRegistry.runApplication('pmsWeb', {
  rootTag: document.getElementById('root')
});